import type { Service } from '@/features/tenant/schemas';

export function priceFor(service: Service, vehicleClassId: string | null): number | null {
  if (!vehicleClassId) return null;
  const p = service.prices[vehicleClassId];
  return typeof p === 'number' ? p : null;
}

export function priceRange(service: Service): number[] {
  return Object.values(service.prices);
}

export interface Selection { mainId: string | null; addonIds: string[] }

export function selectedServices(all: Service[], sel: Selection): Service[] {
  const ids = new Set([...(sel.mainId ? [sel.mainId] : []), ...sel.addonIds]);
  return all.filter((s) => ids.has(s.id));
}

/** Mirrors the server: total of per-class prices, summed durations. Display only — the server recomputes. */
export function quote(all: Service[], sel: Selection, vehicleClassId: string | null) {
  const items = selectedServices(all, sel);
  const prices = items.map((s) => priceFor(s, vehicleClassId));
  return {
    items,
    totalMinor: prices.every((p) => p !== null) && vehicleClassId ? prices.reduce<number>((a, p) => a + (p ?? 0), 0) : null,
    durationMinutes: items.reduce((a, s) => a + s.duration_minutes, 0),
    spansClosedHours: items.some((s) => s.spans_closed_hours),
  };
}
